export default __webpack_public_path__ + "static/media/check-icon.ea453444.png";